exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Avatar__avatar___3TmQW {\n  width: 60px;\n  height: 60px; }\n  .Avatar__avatar___3TmQW .Avatar__img___2THEN {\n    width: 60px !important;\n    height: 60px !important;\n    border-radius: 50%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center; }\n  .Avatar__avatar___3TmQW.Avatar__small___25Dca {\n    width: 48px;\n    height: 48px; }\n    .Avatar__avatar___3TmQW.Avatar__small___25Dca .Avatar__img___2THEN {\n      width: 48px !important;\n      height: 48px !important; }\n  .Avatar__avatar___3TmQW.Avatar__big___2kxnt {\n    width: 90px;\n    height: 90px; }\n    .Avatar__avatar___3TmQW.Avatar__big___2kxnt .Avatar__img___2THEN {\n      width: 90px !important;\n      height: 90px !important; }\n", ""]);

// exports
exports.locals = {
	"avatar": "Avatar__avatar___3TmQW",
	"img": "Avatar__img___2THEN",
	"small": "Avatar__small___25Dca",
	"big": "Avatar__big___2kxnt"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Avatar/Avatar.scss
// module id = 694
// module chunks = 0